import { useState, useEffect, useRef } from "react";
import { inject } from "@vercel/analytics";

const PASSWORD = "holdless";
inject();

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;1,400&family=DM+Sans:wght@400;500;600&display=swap');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'DM Sans', sans-serif; background: #faf8f9; color: #2F4650; min-height: 100vh; }
  .container { max-width: 680px; margin: 0 auto; padding: 48px 24px 80px; }
  .progress-bar { height: 3px; background: #c8bcc4; border-radius: 2px; margin-bottom: 48px; overflow: hidden; }
  .progress-fill { height: 100%; background: #2F4650; border-radius: 2px; transition: width 0.6s ease; }
  .section-label { font-size: 13px; letter-spacing: 0.1em; text-transform: uppercase; color: #3d5a66; font-weight: 600; margin-bottom: 14px; }
  .question-title { font-family: 'Playfair Display', serif; font-size: 28px; line-height: 1.35; color: #2F4650; margin-bottom: 18px; font-weight: 400; }
  .question-subtext { font-size: 16px; line-height: 1.75; color: #3a5260; margin-bottom: 28px; font-weight: 400; }
  .privacy-note { background: #f0e4ec; border-radius: 4px; padding: 16px 20px; font-size: 14px; line-height: 1.65; color: #3a5260; margin-bottom: 32px; }
  .privacy-note strong { color: #2F4650; }
  .textarea { width: 100%; min-height: 160px; border: 2px solid #b8aab4; border-radius: 4px; padding: 18px; font-family: 'DM Sans', sans-serif; font-size: 16px; line-height: 1.65; color: #2F4650; background: white; resize: vertical; transition: border-color 0.2s; outline: none; }
  .textarea:focus { border-color: #2F4650; }
  .textarea::placeholder { color: #7a8e96; }
  .nav-row { display: flex; align-items: center; justify-content: space-between; margin-top: 32px; }
  .btn-primary { background: #2F4650; color: white; border: none; padding: 16px 32px; border-radius: 3px; font-family: 'DM Sans', sans-serif; font-size: 16px; font-weight: 600; letter-spacing: 0.02em; cursor: pointer; transition: opacity 0.15s; }
  .btn-primary:hover { opacity: 0.85; }
  .btn-primary:disabled { opacity: 0.3; cursor: not-allowed; }
  .btn-secondary { background: white; color: #2F4650; border: 2px solid #2F4650; padding: 14px 28px; border-radius: 3px; font-family: 'DM Sans', sans-serif; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.15s; }
  .btn-secondary:hover { background: #f0e4ec; }
  .btn-ghost { background: none; border: none; color: #3a5260; font-family: 'DM Sans', sans-serif; font-size: 15px; font-weight: 500; cursor: pointer; padding: 0; }
  .btn-ghost:hover { color: #2F4650; }
  .btn-ghost:disabled { opacity: 0; pointer-events: none; }
  .divider { height: 1px; background: #b8aab4; margin: 40px 0; }
  .pull-quote { border-left: 4px solid #2F4650; padding: 20px 24px; background: #f0e4ec; font-family: 'Playfair Display', serif; font-size: 19px; line-height: 1.6; font-style: italic; color: #2F4650; border-radius: 0 4px 4px 0; margin-bottom: 40px; }
  .result-wrapper { animation: fadeUp 0.5s ease both; }
  @keyframes fadeUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
  .result-header { background: #2F4650; border-radius: 6px; padding: 40px 36px; margin-bottom: 40px; }
  .result-eyebrow { font-size: 12px; letter-spacing: 0.14em; text-transform: uppercase; color: #e2bfd7; margin-bottom: 12px; font-weight: 600; }
  .result-name { font-family: 'Playfair Display', serif; font-size: 32px; color: white; font-weight: 400; line-height: 1.3; margin-bottom: 12px; }
  .result-tagline { font-size: 17px; color: #c8dce4; font-weight: 400; line-height: 1.6; }
  .result-section { margin-bottom: 36px; }
  .result-section-label { font-size: 11px; letter-spacing: 0.14em; text-transform: uppercase; color: #e2bfd7; font-weight: 600; margin-bottom: 14px; padding: 6px 12px; background: #2F4650; border-radius: 2px; display: inline-block; }
  .result-body { font-size: 17px; line-height: 1.8; color: #243038; font-weight: 400; }
  .result-body p { margin-bottom: 16px; }
  .result-body p:last-child { margin-bottom: 0; }
  .result-bullet { display: flex; gap: 12px; margin-bottom: 14px; font-size: 16px; line-height: 1.7; color: #243038; }
  .result-bullet-dot { width: 6px; height: 6px; border-radius: 50%; background: #e2bfd7; margin-top: 10px; flex-shrink: 0; }
  .hard-question { background: #f0e4ec; border: 2px solid #c8a8be; border-radius: 4px; padding: 24px 28px; font-family: 'Playfair Display', serif; font-size: 20px; font-style: italic; line-height: 1.6; color: #2F4650; }
  .loading-wrapper { text-align: center; padding: 80px 0; }
  .loading-dots { display: flex; gap: 10px; justify-content: center; margin-bottom: 28px; }
  .dot { width: 10px; height: 10px; border-radius: 50%; background: #2F4650; animation: pulse 1.2s ease-in-out infinite; }
  .dot:nth-child(2) { animation-delay: 0.2s; }
  .dot:nth-child(3) { animation-delay: 0.4s; }
  @keyframes pulse { 0%, 80%, 100% { opacity: 0.2; transform: scale(0.8); } 40% { opacity: 1; transform: scale(1); } }
  .loading-text { font-family: 'Playfair Display', serif; font-size: 22px; color: #2F4650; font-style: italic; margin-bottom: 10px; }
  .loading-sub { font-size: 15px; color: #3a5260; font-weight: 400; }
  .intro-title { font-family: 'Playfair Display', serif; font-size: 42px; line-height: 1.2; color: #2F4650; margin-bottom: 12px; }
  .intro-subtitle { font-size: 17px; color: #3a5260; font-style: italic; margin-bottom: 32px; line-height: 1.55; font-weight: 400; }
  .intro-body { font-size: 17px; line-height: 1.8; color: #243038; font-weight: 400; margin-bottom: 18px; }
  .tag-row { display: flex; gap: 10px; flex-wrap: wrap; margin-bottom: 36px; }
  .tag { font-size: 14px; padding: 6px 16px; border-radius: 20px; background: white; color: #2F4650; border: 2px solid #b8aab4; font-weight: 500; }
  .step-indicator { font-size: 15px; color: #3a5260; font-weight: 500; }
  .error-msg { font-size: 15px; color: #a03040; margin-top: 12px; font-weight: 500; padding: 14px 18px; background: #fdf0f0; border-radius: 4px; border: 1px solid #e0b0b8; }
  .bio-section { background: #2F4650; border-radius: 6px; padding: 36px; margin-top: 48px; }
  .bio-eyebrow { font-size: 11px; letter-spacing: 0.14em; text-transform: uppercase; color: #e2bfd7; font-weight: 600; margin-bottom: 16px; }
  .bio-name { font-family: 'Playfair Display', serif; font-size: 24px; color: white; font-weight: 400; margin-bottom: 12px; }
  .bio-text { font-size: 15px; line-height: 1.75; color: #c8dce4; margin-bottom: 24px; }
  .bio-links { display: flex; flex-direction: column; gap: 16px; }
  .bio-link { display: flex; align-items: flex-start; gap: 12px; font-size: 15px; color: white; line-height: 1.5; }
  .bio-link-icon { width: 28px; height: 28px; border-radius: 50%; background: #e2bfd7; display: flex; align-items: center; justify-content: center; flex-shrink: 0; font-size: 13px; color: #2F4650; font-weight: 700; margin-top: 1px; }
  .bio-link-label { color: white; font-weight: 600; font-size: 15px; }
  .bio-link-desc { color: #c8dce4; font-size: 14px; margin-top: 2px; }
  .bio-link-url { color: #e2bfd7; font-size: 14px; margin-top: 4px; display: inline-block; }
  .password-screen { max-width: 400px; }
  .password-input { width: 100%; padding: 16px 18px; font-size: 16px; font-family: 'DM Sans', sans-serif; border-radius: 4px; outline: none; color: #2F4650; background: white; margin-bottom: 12px; }
  @media print {
    .no-print { display: none !important; }
    .container { padding: 0; }
    body { background: white; }
    .result-header, .result-section-label, .hard-question, .bio-section { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  }
`;

const QUESTIONS = [
  {
    id: "what_reach_for",
    section: 0,
    label: "Section 1 of 3 — Name What You've Been Doing",
    title: "When you're depleted, what do you reach for?",
    subtext: "Depletion looks different for everyone. When you hit that wall, what do you actually do?",
    bullets: ["Travel or planning a trip", "Food, shopping, or doomscrolling", "Hard workouts or pushing through", "Numbing out or checking out entirely", "Something else entirely"],
    placeholder: "Take your time. There's no wrong answer here...",
  },
  {
    id: "what_escaping",
    section: 0,
    label: "Section 1 of 3 — Name What You've Been Doing",
    title: "What have you actually been escaping from?",
    subtext: "Not the surface answer. What is the thing underneath that you're really trying to get distance from?",
    bullets: ["A role that no longer fits", "A relationship that costs more than it gives", "A version of yourself you've outgrown", "A feeling you haven't had time to sit with"],
    placeholder: "",
  },
  {
    id: "last_restored",
    section: 0,
    label: "Section 1 of 3 — Name What You've Been Doing",
    title: "When did you last feel genuinely restored?",
    subtext: "Not recovered enough to function. Actually restored, where something in you settled.",
    bullets: ["What were you doing?", "What was notably absent?", "What did your body feel like?", "If you can't remember, that's worth noting too"],
    placeholder: "",
  },
  {
    id: "who_benefits",
    section: 1,
    label: "Section 2 of 3 — Understand the Structure",
    title: "Who benefits from your particular variety of depletion?",
    subtext: "What does the structure around you get from you staying exhausted?",
    bullets: ["Your workplace or industry", "Your family system", "What becomes possible for others when you keep saying yes", "Who needs you to stay just depleted enough to keep complying"],
    placeholder: "",
  },
  {
    id: "urgency_check",
    section: 1,
    label: "Section 2 of 3 — Understand the Structure",
    title: "When you feel urgency, how much of it is actually yours?",
    subtext: "The system runs on urgency that isn't real.",
    bullets: ["What felt urgent last week?", "How much of it actually was?", "What would have happened if you hadn't responded immediately?", "Where does the urgency come from?"],
    placeholder: "",
  },
  {
    id: "buying_bearable",
    section: 1,
    label: "Section 2 of 3 — Understand the Structure",
    title: "What have you been buying to make the depletion bearable?",
    subtext: "There's no judgment here. This is one of the ways the system sustains itself.",
    bullets: ["Travel, food, or treats that make the week survivable", "Courses, books, or self-improvement purchases", "Supplements or wellness spending", "What would change if you needed it less?"],
    placeholder: "",
  },
  {
    id: "genuine_restoration",
    section: 2,
    label: "Section 3 of 3 — Build Something Different",
    title: "What genuinely restores you?",
    subtext: "Not because it's productive or impressive. Because it brings you back to yourself.",
    bullets: ["Even if it's small or doesn't sound like much", "Moments where you felt actually present", "Not performing rest, not optimizing recovery", "What was happening in those moments?"],
    placeholder: "",
  },
  {
    id: "in_the_way",
    section: 2,
    label: "Section 3 of 3 — Build Something Different",
    title: "What would you need to protect in order for that to happen more often?",
    subtext: "And what is currently in the way?",
    bullets: ["Not 'I don't have time' but what is actually consuming that time", "What you would have to say no to", "What conditions would need to change", "What you are waiting for permission to do"],
    placeholder: "",
  },
  {
    id: "micro_recovery",
    section: 2,
    label: "Section 3 of 3 — Build Something Different",
    title: "What is one micro-recovery you could weave into the next seven days?",
    subtext: "A micro-recovery is a small, real act of restoration that requires nothing except your presence.",
    bullets: ["Ten minutes outside without your phone", "Cooking one meal slowly and actually noticing it", "A walk with no destination and no step count", "The smallest version of restoration that feels true right now"],
    placeholder: "Something small and real...",
  },
];

async function generateGuide(answers) {
  const formatted = QUESTIONS.map(q => {
    const val = answers[q.id];
    if (!val) return null;
    return `${q.title}\nAnswer: ${val}`;
  }).filter(Boolean).join("\n\n");

  const prompt = `You are a compassionate burnout and recovery coach named Nicole Johnson. Based on someone's answers to a reflective recovery practice workbook, generate a personalized recovery guide.

Their answers:
${formatted}

Be specific, warm, direct, and grounded in their actual answers. Reference what they said. Do not be generic. Do not use em dashes. Do not use the word "midlife". Do not use "resonates". Do not use "quietly". Speak to systemic extraction, not personal failing. If someone indicates they are recovering well, honor that.

Return ONLY a JSON object:
{
  "name": "A 4-6 word name for their personal recovery practice (evocative, not generic)",
  "tagline": "One sentence capturing their specific situation",
  "extraction_patterns": ["specific pattern 1", "specific pattern 2", "specific pattern 3"],
  "recovery_practices": ["specific practice 1 grounded in their words", "specific practice 2", "specific practice 3"],
  "hard_question": "One hard question to sit with this week. Not a task. A question that opens something."
}

Return only the JSON. No preamble, no markdown backticks.`;

  const response = await fetch("https://api.anthropic.com/v1/messages", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      model: "claude-sonnet-4-20250514",
      max_tokens: 1200,
      messages: [{ role: "user", content: prompt }]
    })
  });

  if (!response.ok) throw new Error(`API error: ${response.status}`);
  const data = await response.json();
  const text = data.content.map(b => b.text || "").join("");
  return JSON.parse(text.replace(/```json|```/g, "").trim());
}

const Logo = () => (
  <div style={{ marginBottom: 40 }}>
    <svg width="129" height="72" viewBox="0 0 129 72" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="129" height="36" fill="#2F4650"/>
      <text x="9" y="26" fontFamily="'DM Sans', sans-serif" fontSize="22" fontWeight="400" fill="#e2bfd7" letterSpacing="0.5">Drop More</text>
      <text x="9" y="62" fontFamily="'DM Sans', sans-serif" fontSize="22" fontWeight="400" fill="#2F4650" letterSpacing="1.6">Hold Less</text>
    </svg>
  </div>
);

export default function App() {
  const [screen, setScreen] = useState("password");
  const [passwordInput, setPasswordInput] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const [currentQ, setCurrentQ] = useState(0);
  const [answers, setAnswers] = useState({});
  const [result, setResult] = useState(null);
  const topRef = useRef(null);

  const q = QUESTIONS[currentQ];
  const progress = (currentQ / QUESTIONS.length) * 100;
  const canAdvance = answers[q?.id] && answers[q?.id].toString().trim().length > 0;

  useEffect(() => {
    topRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [currentQ, screen]);

  function handlePasswordSubmit() {
    if (passwordInput.trim().toLowerCase() === PASSWORD) {
      setScreen("intro");
      setPasswordError(false);
    } else {
      setPasswordError(true);
    }
  }

  function handleAnswer(val) {
    setAnswers(prev => ({ ...prev, [q.id]: val }));
  }

  function handleNext() {
    if (currentQ < QUESTIONS.length - 1) {
      setCurrentQ(i => i + 1);
    } else {
      handleSubmit();
    }
  }

  function handleBack() {
    if (currentQ > 0) setCurrentQ(i => i - 1);
  }

  async function handleSubmit() {
    setScreen("loading");
    try {
      const guide = await generateGuide(answers);
      setResult(guide);
      setScreen("result");
    } catch (e) {
      setScreen("error");
    }
  }

  return (
    <>
      <style>{styles}</style>
      <div className="container" ref={topRef}>
        <Logo />

        {screen === "password" && (
          <div className="password-screen">
            <div className="question-title" style={{ fontSize: 24, marginBottom: 12 }}>Enter your access code</div>
            <div className="question-subtext" style={{ marginBottom: 24 }}>
              This practice is for paid subscribers of Drop More, Hold Less. Your access code is in the Substack post.
            </div>
            <input
              type="password"
              className="password-input"
              value={passwordInput}
              onChange={e => setPasswordInput(e.target.value)}
              onKeyDown={e => e.key === "Enter" && handlePasswordSubmit()}
              placeholder="Access code"
              style={{ border: `2px solid ${passwordError ? "#a03040" : "#b8aab4"}` }}
            />
            {passwordError && (
              <div style={{ fontSize: 14, color: "#a03040", marginBottom: 16 }}>
                That code doesn't match. Check the Substack post and try again.
              </div>
            )}
            <button className="btn-primary" onClick={handlePasswordSubmit}>Enter</button>
          </div>
        )}

        {screen === "intro" && (
          <div>
            <div className="intro-title">Less Exploitable</div>
            <div className="intro-subtitle">A recovery practice for people who are tired of optimizing their exhaustion</div>
            <div className="tag-row">
              <span className="tag">9 questions</span>
              <span className="tag">~10-15 minutes</span>
              <span className="tag">Personalized guide at the end</span>
            </div>
            <p className="intro-body">Most of what gets sold as recovery is optimization with better branding. A nicer escape route back to the same extraction.</p>
            <p className="intro-body">This practice asks harder questions: what have you actually been doing when you thought you were recovering? Who benefits from your particular variety of depletion? What would change if your nervous system had enough room to tell you what is actually true?</p>
            <p className="intro-body">At the end, you'll receive a personalized recovery guide built from what you actually said.</p>
            <div className="privacy-note">
              <strong>Your privacy:</strong> Your answers are not stored anywhere. They exist only in your browser session, are sent directly to generate your guide, and are then discarded. No one else can see what you write here.
            </div>
            <div className="pull-quote">"A rested person is a different negotiating partner. With her employer, her time, her attention, her money."</div>
            <button className="btn-primary" onClick={() => setScreen("questions")}>Begin the practice</button>
          </div>
        )}

        {screen === "questions" && q && (
          <div>
            <div className="progress-bar">
              <div className="progress-fill" style={{ width: `${progress}%` }} />
            </div>
            <div className="section-label">{q.label}</div>
            <div className="question-title">{q.title}</div>
            {q.subtext && <div className="question-subtext">{q.subtext}</div>}
            {q.bullets && q.bullets.length > 0 && (
              <div style={{ marginBottom: 24 }}>
                <div style={{ fontSize: 13, fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase", color: "#3d5a66", marginBottom: 10 }}>Some things to consider</div>
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {q.bullets.map((b, i) => (
                    <li key={i} style={{ display: "flex", gap: 10, marginBottom: 8, fontSize: 15, color: "#3a5260", lineHeight: 1.5 }}>
                      <span style={{ color: "#e2bfd7", fontWeight: 700, flexShrink: 0, marginTop: 1 }}>—</span>
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <textarea
              className="textarea"
              value={answers[q.id] || ""}
              onChange={e => handleAnswer(e.target.value)}
              placeholder={q.placeholder}
            />
            <div className="nav-row">
              <button className="btn-ghost" onClick={handleBack} disabled={currentQ === 0}>← Back</button>
              <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
                <span className="step-indicator">{currentQ + 1} of {QUESTIONS.length}</span>
                <button className="btn-primary" onClick={handleNext} disabled={!canAdvance}>
                  {currentQ === QUESTIONS.length - 1 ? "Generate my guide" : "Continue →"}
                </button>
              </div>
            </div>
          </div>
        )}

        {screen === "loading" && (
          <div className="loading-wrapper">
            <div className="loading-dots">
              <div className="dot" /><div className="dot" /><div className="dot" />
            </div>
            <div className="loading-text">Building your recovery guide</div>
            <div className="loading-sub">This takes about 15 seconds</div>
          </div>
        )}

        {screen === "error" && (
          <div style={{ padding: "60px 0" }}>
            <div className="error-msg" style={{ marginBottom: 28 }}>
              Something went wrong generating your guide. This is usually temporary. Your answers are still saved.
            </div>
            <button className="btn-primary" onClick={handleSubmit}>Try again</button>
          </div>
        )}

        {screen === "result" && result && (
          <div className="result-wrapper">
            <div className="result-header">
              <div className="result-eyebrow">Your personalized recovery guide</div>
              <div className="result-name">{result.name}</div>
              <div className="result-tagline">{result.tagline}</div>
            </div>

            <div className="result-section">
              <div className="result-section-label">What the structure is getting from you</div>
              <div style={{ marginTop: 16 }}>
                {(Array.isArray(result.extraction_patterns)
                  ? result.extraction_patterns
                  : result.extraction_patterns.split("\n").filter(Boolean)
                ).map((p, i) => (
                  <div key={i} className="result-bullet">
                    <div className="result-bullet-dot" />
                    <div style={{ fontSize: 16, lineHeight: 1.7, color: "#243038" }}>{p}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="divider" />

            <div className="result-section">
              <div className="result-section-label">Your recovery practices</div>
              <div style={{ marginTop: 16 }}>
                {(Array.isArray(result.recovery_practices)
                  ? result.recovery_practices
                  : result.recovery_practices.split("\n").filter(Boolean)
                ).map((p, i) => (
                  <div key={i} className="result-bullet">
                    <div className="result-bullet-dot" />
                    <div style={{ fontSize: 16, lineHeight: 1.7, color: "#243038" }}>{p}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="divider" />

            <div className="result-section">
              <div className="result-section-label">One question to sit with this week</div>
              <div className="hard-question" style={{ marginTop: 16 }}>{result.hard_question}</div>
            </div>

            <div className="divider no-print" />

            <div className="no-print" style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
              <button className="btn-primary" onClick={() => window.print()}>Save as PDF</button>
              <button className="btn-secondary" onClick={() => { setScreen("questions"); setCurrentQ(0); setResult(null); setAnswers({}); }}>Start over</button>
            </div>

            <div className="bio-section">
              <div className="bio-eyebrow">About Nicole Johnson</div>
              <div className="bio-name">Executive and burnout coach. UX consultant.</div>
              <div className="bio-text">Nicole writes about nervous system regulation, the cost of invisible labor, and what becomes possible when you stop absorbing what was never yours to carry.</div>
              <div className="bio-links">
                <div className="bio-link">
                  <div className="bio-link-icon">1</div>
                  <div>
                    <div className="bio-link-label">Free Energy Audit</div>
                    <div className="bio-link-desc">Map where your energy is being gained and drained. Leave with micro-recoveries to weave into your day immediately.</div>
                    <a href="https://www.dropmoreholdless.com/energy-audits" target="_blank" rel="noopener noreferrer" className="bio-link-url">Book here</a>
                  </div>
                </div>
                <div className="bio-link">
                  <div className="bio-link-icon">2</div>
                  <div>
                    <div className="bio-link-label">1:1 Coaching</div>
                    <div className="bio-link-desc">For high achievers who are ready to build something sustainable. Start with a discovery call.</div>
                    <a href="https://www.dropmoreholdless.com/work" target="_blank" rel="noopener noreferrer" className="bio-link-url">Learn more</a>
                  </div>
                </div>
                <div className="bio-link">
                  <div className="bio-link-icon">3</div>
                  <div>
                    <div className="bio-link-label">Workshops and Workplace Trainings</div>
                    <div className="bio-link-desc">Bring this work into your team or organization.</div>
                    <a href="mailto:nicole@dropmoreholdless.com" className="bio-link-url">nicole@dropmoreholdless.com</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
